<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Craggy Range</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Di medio corpo, scuro e molto buono; no, non è il tuo prossimo appuntamento su Tinder, sono i vini superlativi di Craggy Range. L'equivalente vinoso di un tour della Hawke's Bay in Nuova Zelanda, Craggy Range potrebbe essere un po' un novellino del mondo, ma ha molto da dire su se stesso. Di proprietà di Terry
                        Peabody e sua moglie Mary, le future generazioni di Peabody non dovranno cercare lavoro lontano
                        (né avranno molta scelta nelle opzioni di carriera). La terra è in un trust di 1.000 anni che significa no
                        solo Peabody ha una grande fiducia nella longevità del suo vino, ma anche nel pianeta. Questo
                        significa che la Craggy Range non potrà mai essere venduta e l'eredità di Terry e Mary vivrà a lungo
                        dopo che se ne sono andati.
                    </div>

                    <div class="howto-title2">La passione si è trasformata in devozione</div>
                    <div class="howto-text">
                        Nonostante il background di Terry non fosse nel vino (era "grande nel settore dell'ospitalità"), lo aveva fatto
                        è sempre stato una specie di enologo del fine settimana, quindi il suo annuncio nei primi anni '90 che lui
                        stava per acquistare un terroir e avviare il proprio vigneto è stata solo una mezza sorpresa. Qualche anno
                        di cercare in aree consolidate sature - pensa alla Borgogna e Napa, è atterrato a New
                        Zelanda, nel distretto di Gimblett Gravels. Con l'aiuto del famoso enologo Kiwi Steve Smith,
                        hanno selezionato diversi appezzamenti di terreno e piantato diverse varietà tra cui Syrah, Pinot
                        Noir e Cabernet Sauvignon. Aggiungi uno stato dell'arte, nessuna cantina badata a spese e hai
                        investimenti pesanti che stanno iniziando a dare risultati molto interessanti. Smith da allora se n'è andato
                        Craggy Range lascia al comando l'ex Giant Steps Julian Grounds.
                    </div>

                    <div class="howto-title2">Collezione 2019 esaurita prima del rilascio</div>
                    <div class="howto-text">
                        I critici elogiano continuamente le miscele distintive di Craggy Hill e, come la maggior parte del nuovo mondo
                        vini, ha un prezzo ridicolmente basso (un Le Sol del 2016, 93/100 punti, uno dei loro migliori vini e
                        vini più costosi è di circa € 70 sul mercato secondario). I vini secondari sono più vicini al
                        Marco 10-20€. La crescita sostenuta, tuttavia, si è rivelata irregolare per Craggy Hill, ma non è così
                        significa che dovresti ignorarlo. Al contrario, prendilo mentre è economico come con un progetto
                        aspettativa come la loro, una delle prime bottiglie sarà una benedizione.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Craggy Range</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Mittelkräftig, dunkel und sehr gut; Nein, es ist nicht Ihr nächstes Tinder-Date, es sind die Weine der Superlative von Craggy Range. Craggy Range ist das weinige Äquivalent einer Tour durch die neuseeländische Hawke’s Bay und mag zwar ein bisschen wie ein Neuling in der Welt sein, hat aber viel für sich zu sagen. Im Besitz von Terry
                        Peabody und seine Frau Mary, zukünftige Generationen von Peabodys werden nicht lange nach Arbeit suchen müssen
                        (Sie werden auch keine große Auswahl an Karrieremöglichkeiten haben). Das Land befindet sich in einem 1000-jährigen Trust, was bedeutet, dass dies nicht der Fall ist
                        Peabody hat nicht nur großes Vertrauen in die Langlebigkeit seines Weins, sondern auch in den Planeten. Das
                        bedeutet, dass die Craggy Range niemals verkauft werden kann und das Erbe von Terry und Mary lange weiterleben wird
                        nachdem sie weg sind.
                    </div>

                    <div class="howto-title2">Aus Leidenschaft wurde Hingabe</div>
                    <div class="howto-text">
                        Obwohl Terry nicht aus der Weinbranche kam (er war „groß im Gastgewerbe“), hatte er es
                        war schon immer so etwas wie ein Wochenend-Önologe, so seine Ankündigung Anfang der 90er Jahre, dass er
                        Der Plan, ein Terroir zu kaufen und einen eigenen Weinberg anzulegen, war nur eine halbe Überraschung. Ein paar Jahren
                        Bei der Suche in gesättigten etablierten Gebieten – denken Sie an Burgund und Napa – landete er in New
                        Zealand, im Bezirk Gimblett Gravels. Mit der Hilfe des renommierten Kiwi-Winzers Steve Smith,
                        Sie wählten verschiedene Parzellen aus und pflanzten verschiedene Rebsorten an, darunter Syrah und Pinot
                        Noir und Cabernet Sauvignon. Fügen Sie noch ein hochmodernes Weingut hinzu, bei dem keine Kosten gescheut werden, und schon haben Sie es
                        Es werden umfangreiche Investitionen getätigt, die einige sehr interessante Ergebnisse hervorbringen. Smith ist inzwischen gegangen
                        Craggy Range überlässt Ex-Giant Steps Julian Grounds das Kommando.
                    </div>

                    <div class="howto-title2">Kollektion 2019 vor Veröffentlichung ausverkauft</div>
                    <div class="howto-text">
                        Kritiker loben immer wieder die charakteristischen Mischungen von Craggy Hill und wie die meisten neuen Produkte auf der Welt
                        Weine, ist lächerlich unterbewertet (ein 2016er Le Sol, 93/100 Punkte, einer ihrer besten Weine und
                        (Der teuerste Wein liegt auf dem Zweitmarkt bei etwa 70 €). Sekundärweine liegen näher an der
                        10-20€-Marke. Das anhaltende Wachstum hat sich für Craggy Hill jedoch als unberechenbar erwiesen, was jedoch nicht der Fall ist
                        bedeuten, dass Sie es ignorieren sollten. Im Gegenteil, bekommen Sie es, während es günstiger ist als bei einem projizierten
                        Bei einer solchen Erwartungshaltung wird eine der ersten Flaschen ein Segen sein.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Craggy Range</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Moyennement corsé, sombre et très bon; non, ce n'est pas votre prochain rendez-vous Tinder, ce sont les vins superlatifs de Craggy Range. L'équivalent vineux d'une visite de Hawke's Bay en Nouvelle-Zélande, Craggy Range est peut-être un peu un nouveau venu du monde, mais il a beaucoup à dire pour lui-même. Possédé par Terry
                        Peabody et sa femme Mary, les futures générations de Peabodys n'auront pas à chercher bien loin pour trouver du travail
                        (ils n'auront pas non plus beaucoup de choix dans les options de carrière). La terre est dans une fiducie de 1 000 ans, ce qui signifie non
                        seulement Peabody a une grande confiance dans la longévité de son vin, mais dans la planète en plus. Ce
                        signifie que la gamme Craggy ne pourra jamais être vendue et que l'héritage de Terry et Mary vivra longtemps
                        après leur départ.
                    </div>

                    <div class="howto-title2">La passion s'est transformée en dévotion</div>
                    <div class="howto-text">
                        Bien que les antécédents de Terry ne soient pas dans le domaine du vin (il était «grand dans le secteur de l'hôtellerie»), il avait
                        toujours été un peu l'œnologue du week-end, d'où son annonce au début des années 90 qu'il
                        allait acheter un terroir et démarrer son propre vignoble n'était qu'une demi-surprise. Quelques années
                        de chercher dans des zones établies saturées - pensez à la Bourgogne et à Napa, il a atterri à New
                        Zealand, dans le district de Gimblett Gravels. Avec l'aide du célèbre vigneron kiwi Steve Smith,
                        ils ont sélectionné différentes parcelles de terre et planté différents cépages dont Syrah, Pinot
                        Noir et Cabernet Sauvignon. Ajoutez une cave à la fine pointe de la technologie, aucune dépense n'a été épargnée et vous avez
                        des investissements lourds qui commencent à donner des résultats très intéressants. Smith est parti depuis
                        Craggy Range laissant l'ex-Giant Steps Julian Grounds en charge.
                    </div>

                    <div class="howto-title2">Collection 2019 épuisée avant sa sortie</div>
                    <div class="howto-text">
                        Les critiques ne cessent de faire l'éloge des mélanges emblématiques de Craggy Hill et, comme la plupart des nouveaux mondes
                        vins, est ridiculement sous-évalué (un Le Sol 2016, 93/100 points, un de leurs meilleurs vins et
                        les vins les plus chers se situent autour de 70 € sur le marché secondaire). Les vins secondaires sont plus proches des
                        Marque 10-20 €. Cependant, la croissance soutenue s'est avérée erratique pour Craggy Hill, mais cela ne signifie pas
                        signifie que vous devez l'ignorer. Au contraire, obtenez-le alors qu'il est bon marché comme avec un projeté
                        attente comme la leur, l'une des premières bouteilles sera une bénédiction.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Craggy Range</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Medium-bodied, dark and very good; no, it’s not your next Tinder date, it’s the superlative wines of Craggy Range. The vinous equivalent of a tour of New Zealand’s Hawke’s Bay, Craggy Range might be a bit of a new world newbie but it has a lot to say for itself. Owned by Terry
                        Peabody and his wife Mary, future generations of Peabodys will not have to look far for work
                        (nor will they get much choice in career options). The land is in a 1,000-year trust meaning not
                        only does Peabody has great faith in the longevity of his wine, but in the planet to boot. This
                        means that the Craggy Range can never be sold and Terry and Mary’s legacy will live on long
                        after they’re gone.
                    </div>

                    <div class="howto-title2">Passion turned to devotion</div>
                    <div class="howto-text">
                        Despite Terry’s background not being in wine (he was “big in the hospitality business”), he had
                        always been something of a weekend oenologist, thus his announcement in the early 90s that he
                        was going to buy a terroir and start his own vineyard came as only a semi-surprise. A few years
                        of searching in saturated established areas – think Burgundy and Napa, he landed up in New
                        Zealand, in the Gimblett Gravels district. With the help of renowned Kiwi winemaker Steve Smith,
                        they selected different parcels of land and planted different varietals including Syrah, Pinot
                        Noir and Cabernet Sauvignon. Add in a state of the art, no expense spared winery and you have
                        heavy investing that is beginning to yield some very interesting results. Smith has since left
                        Craggy Range leaving ex-Giant Steps Julian Grounds in charge.
                    </div>

                    <div class="howto-title2">2019 Collection sold out before release</div>
                    <div class="howto-text">
                        Critics continually heap praise on Craggy Hill’s signature blends and, like most new world
                        wines, is ridiculously under-priced (a 2016 Le Sol, 93/100 points, one of their best wine and
                        most expensive wines is around €70 on the secondary market). Secondary wines are closer to the
                        €10-20 mark. Sustained growth, however, has proved erratic for Craggy Hill, but that does not
                        mean that you should ignore it. Au contraire, get it while it is cheap as with a projected
                        expectancy such as theirs, one of the early bottles will be a blessing.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CraggyRange",
    data() {
        return {
            select: {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Craggy Range | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wines of Craggy Range, a leading New Zealand wine producer known for their commitment to quality and innovation in winemaking. Explore their diverse range of vineyards and taste the premium wines of Craggy Range.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
